import React from "react";

const LoginDesktop = React.lazy(() => import("./ui/Login"));

export const LoginPage = () => {
  return <LoginDesktop />;
};
